import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {generateLettersForUserId} from '../../../../actions/facilita-api';
import * as loadings from '../../../../constants/loadings/facilita/deathDeclaration';

import loadingPrimary from './../../../../assets/images/placeholder/loading-primary.png';
import loadingSecondary from './../../../../assets/images/placeholder/loading-secondary.png';

export const DossierLoading = ({userId, isLoading}) => {
	const dispatch = useDispatch();

	const [hasLauchedGeneration, setHasLauchedGeneration] = useState(false);

	useEffect(() => {
		dispatch(generateLettersForUserId(userId))
		.then(() => setHasLauchedGeneration(true))
		.catch(() => setHasLauchedGeneration(true));
	}, []);

	if(!hasLauchedGeneration || isLoading.includes(loadings.GENERATING_USER_LETTERS + "_" + userId)){
		return (
			<article className="view-calc py-sm my-auto">
				<div className="container-fluid h-inherit flex-column">
					<div className="block container-thin text-center m-auto transition-base">
						<div className="loader loader-animated mx-auto">
							<img className="img-fluid loader-item" width="60" src={loadingPrimary} alt="loading primary" />
							<img className="img-fluid loader-item o-80" width="60" src={loadingSecondary} alt="loading secondary" />
						{/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 343 400" className="loader-item">
							<path fill="#BE3057" d="M306.066666,131.477768 L126.533333,13.5444346 C72.2000003,-22.1222321 0,16.8111013 0,81.8111013 L0,317.677768 C0,382.677768 72.2000003,421.611102 126.533333,385.944435 L306.066666,268.011102 C355.133333,235.744435 355.133333,163.744435 306.066666,131.477768 Z" />
							</svg>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 343 400" className="loader-item text-secondary o-80">
								<path fill="currentColor" d="M36.8000003,131.477768 L216.333333,13.5444346 C270.666666,-22.1222321 342.866667,16.8111013 342.866667,81.8111013 L342.866667,317.677768 C342.866667,382.677768 270.666666,421.611102 216.333333,385.944435 L36.8000003,268.011102 C-12.2666668,235.744435 -12.2666668,163.744435 36.8000003,131.477768 Z" />
							</svg> */}
							{/* <div className="loader-item h-5 w-5 bg-primary rounded o-90"></div>
							<div className="loader-item h-5 w-5 bg-secondary rounded o-90"></div> */}
						</div>
						<h1 className="text-secondary mt-4">Veuillez patienter</h1>
						<p className="o-80 lh-copy mt-2 transition-base mb-0">Nous sommes en train de générer les courriers...</p>
					</div>
				</div>
			</article>
		)
	} else {
		return (
			<article className="view-calc py-sm my-auto">
				<div className="container-fluid h-inherit flex-column">
					<div className="block container-press text-center m-auto transition-base">
						<div className="loader mx-auto">
							<img className="img-fluid loader-item" width="60" src={loadingPrimary} alt="loading primary" />
							<img className="img-fluid loader-item o-80" width="60" src={loadingSecondary} alt="loading secondary" />
						</div>
						<h1 className="text-aux mt-4">Les courriers ont été générés!</h1>
						<p className="o-80 lh-copy mt-2 mb-4 transition-base">Veuillez cliquez ci-dessous pour accéder au tableau de bord et valider les courriers à envoyer.</p>
						{/* <Link className="btn btn-aux" to={`/facilita/${userId}`}>Accéder au tableau de bord</Link> */}
						<button
							className="btn btn-aux"
							onClick={() => {
								window.location.href = `/facilita/${userId}`;
							}}>
							Accéder au tableau de bord
						</button>
					</div>
				</div>
			</article>
		);
		// return <Redirect to={`/facilita/${userId}`} />
	}

	
}